import { ItemResponse, RequestHeaders, RequestParams, WithCreate, WithPagination, WithShow, WithUpdate } from '@bv/api';
import { mixinClass } from '@bv/utils';

import { ContactDetailsData } from '@/types/api/webPhone/nestedViews/Contact';

class ContactsApi extends mixinClass(
  WithCreate,
  WithUpdate<ContactDetailsData>,
  WithShow<ContactDetailsData>,
  WithPagination<ContactDetailsData>,
) {
  public constructor(public endpoint = 'contacts/contacts') {
    super(endpoint);
  }

  public async update(
    id: string | number,
    formData: FormData,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<ContactDetailsData> {
    const data = new FormData();

    for (const [key, value] of formData.entries()) {
      data.append(key, value);
    }
    data.append('_method', 'PUT');
    return this.request<ContactDetailsData, ItemResponse<ContactDetailsData>>({
      method: 'post',
      url: id.toString(),
      data,
      params,
      headers,
    }).then((response) => {
      return response.data;
    });
  }

  public async addFavoriteContact(contactId: string | number): Promise<ContactDetailsData> {
    return this.request<ContactDetailsData, ItemResponse<ContactDetailsData>>({
      method: 'post',
      url: `${contactId}/favorite`,
    }).then((response) => {
      return response.data;
    });
  }
  public async deleteFavoriteContact(contactId: string | number): Promise<void> {
    return this.request({
      method: 'delete',
      url: `${contactId}/favorite`,
    });
  }
}

export const contactsApi = new ContactsApi();
